module.exports = __webpack_public_path__ + "0-es2015.worker.js"